import { BASE_URL } from "../constants";
import { VendorEntity } from "../entities/VendorEntity";
import FetchUtils from "../utils/fetch";

class VendorService {
    static async GetAllVendor(): Promise<VendorEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors`);
        if (resp.status != 200) { throw resp.message }

        const data: VendorEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new VendorEntity({
                id: resp.data[i].ID,
                nama: resp.data[i].Nama,
                deskripsi: resp.data[i].Deskripsi,
            }))
        }

        return data;
    }

    static async AddVendor(data: { nama: string, deskripsi: string }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateVendor(data: VendorEntity, fields: { nama?: string, deskripsi?: string }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteVendor(data: VendorEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { VendorService };